import { Button, styled } from 'opensolar-ui'

export const ProductNameCellSearchContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
})

export const SearchInputContainer = styled('div')({
  width: '100%',
})

export const SuggestionListActionContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '0px 8px',
})

export const SuggestionListActionWrapper = styled('div')(({ theme }) => ({
  padding: '4px 0px',
  borderTop: `1px solid ${theme.palette.divider}`,
  width: '100%',
}))

export const StyledBrowseComponentsButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  textAlign: 'left',
  justifyContent: 'flex-start',
  width: '100%',
  '&:hover': {
    backgroundColor: theme.palette.blue[200],
  },
}))
